import { isCompositeFilterDescriptor } from "./filter-descriptor.interface";
import { getter } from "../accessor";
import { isFunction, isPresent, isDate, isString, isBlank, isNumeric } from "../utils";
var logic = {
  "or": {
    concat: function concat(acc, fn) {
      return function (a) {
        return acc(a) || fn(a);
      };
    },
    identity: function identity() {
      return false;
    }
  },
  "and": {
    concat: function concat(acc, fn) {
      return function (a) {
        return acc(a) && fn(a);
      };
    },
    identity: function identity() {
      return true;
    }
  }
};
var operatorsMap = {
  contains: function contains(a, b) {
    return (a || "").indexOf(b) >= 0;
  },
  doesnotcontain: function doesnotcontain(a, b) {
    return (a || "").indexOf(b) === -1;
  },
  doesnotendwith: function doesnotendwith(a, b) {
    return (a || "").indexOf(b, (a || "").length - (b || "").length) < 0;
  },
  doesnotstartwith: function doesnotstartwith(a, b) {
    return (a || "").lastIndexOf(b, 0) === -1;
  },
  endswith: function endswith(a, b) {
    return (a || "").indexOf(b, (a || "").length - (b || "").length) >= 0;
  },
  eq: function eq(a, b) {
    return a === b;
  },
  gt: function gt(a, b) {
    return a > b;
  },
  gte: function gte(a, b) {
    return a >= b;
  },
  isempty: function isempty(a) {
    return a === '';
  },
  isnotempty: function isnotempty(a) {
    return a !== '';
  },
  isnotnull: function isnotnull(a) {
    return isPresent(a);
  },
  isnull: function isnull(a) {
    return isBlank(a);
  },
  lt: function lt(a, b) {
    return a < b;
  },
  lte: function lte(a, b) {
    return a <= b;
  },
  neq: function neq(a, b) {
    return a != b;
  },
  startswith: function startswith(a, b) {
    return (a || "").lastIndexOf(b, 0) === 0;
  }
};
var dateRegExp = /^\/Date\((.*?)\)\/$/;

var convertValue = function convertValue(value, ignoreCase) {
  if (value != null && isString(value)) {
    var date = dateRegExp.exec(value);

    if (date) {
      return new Date(+date[1]).getTime();
    } else if (ignoreCase) {
      return value.toLowerCase();
    }
  } else if (value != null && isDate(value)) {
    return value.getTime();
  }

  return value;
};

var typedGetter = function typedGetter(prop, value, ignoreCase) {
  if (!isPresent(value)) {
    return prop;
  }

  var acc = prop;

  if (isString(value)) {
    var date = dateRegExp.exec(value);

    if (date) {
      value = new Date(+date[1]);
    } else {
      acc = function acc(a) {
        var x = prop(a);

        if (typeof x === 'string' && ignoreCase) {
          return x.toLowerCase();
        } else {
          return isNumeric(x) ? x + "" : x;
        }
      };
    }
  }

  if (isDate(value)) {
    return function (a) {
      var x = acc(a);
      return isDate(x) ? x.getTime() : x;
    };
  }

  return acc;
};

var transformFilter = function transformFilter(_a) {
  var field = _a.field,
      ignoreCase = _a.ignoreCase,
      value = _a.value,
      operator = _a.operator;
  field = !isPresent(field) ? function (a) {
    return a;
  } : field;
  ignoreCase = isPresent(ignoreCase) ? ignoreCase : true;
  var itemProp = typedGetter(isFunction(field) ? field : getter(field, true), value, ignoreCase);
  value = convertValue(value, ignoreCase);
  var op = isFunction(operator) ? operator : operatorsMap[operator];
  return function (a) {
    return op(itemProp(a), value, ignoreCase);
  };
};
/**
 * @hidden
 */


export var transformCompositeFilter = function transformCompositeFilter(filter) {
  var combiner = logic[filter.logic];
  return filter.filters.filter(isPresent).map(function (x) {
    return isCompositeFilterDescriptor(x) ? transformCompositeFilter(x) : transformFilter(x);
  }).reduce(combiner.concat, combiner.identity);
};